import { ApiHosts, handleResponseWithNon200Errors, makeGet } from '../../api/helpers';
import { Article, ArticleRequestParams } from './article.types';

/**
 * Fetches a guide article from seo-content-service.
 */
export const fetchArticleByTopicAndSlug = async ({
    deployment,
    slug,
    topic,
}: ArticleRequestParams): Promise<Article | null> =>
    new Promise((resolve, reject) => {
        const request = makeGet({
            apiPath: `${topic}/${slug}`,
            deployment,
            path: ApiHosts.Articles,
        });
        request.end((err, response) => {
            // Soft-404: missing articles resolve null so the page can render soft-404
            if (err?.status === 404) {
                return resolve(null);
            }
            handleResponseWithNon200Errors({ err, reject, request, resolve, response });
        });
    });
